export default "__VITE_ASSET__DQzU3GRc__"